import { Text, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { ResponsesFundItemResponse } from '@genial/services/dist/models';
import { useBreakpointValue } from '@genial/utils';
import { Box, FlatList } from 'native-base';
import React from 'react';

import { dataContent } from '../../../../../../constants';
import { PositionItem } from '../PositionItem';
import { TableHead } from '../TableHead';

interface PositionDetailsTableProps {
  data: ResponsesFundItemResponse[];
}
export const ItemSeparatorComponent = () => <Box bg={'neutral.lightest'} h={0.8} />;

export const PositionDetailsTable: React.FC<PositionDetailsTableProps> = ({ data }) => {
  const headParams = dataContent.fundPositionStatements;
  const isDesktop = useBreakpointValue({ base: false, lg: true });
  return (
    <VStack space={Spacing['inline.xxxs']}>
      <Box
        alignItems={'center'}
        py={Spacing['inline.nano']}
        bg={'background'}
        borderRadius={BoxRadius.sm}>
        <Text color={'neutral.dark'} fontSize={Typography['fontsize.lg']} variant="semibold">
          Posição
        </Text>
      </Box>
      <VStack>
        {isDesktop && <TableHead {...headParams} />}
        <FlatList
          data={data}
          showsVerticalScrollIndicator={false}
          {...(!isDesktop && { ItemSeparatorComponent })}
          keyExtractor={(item, index) => item.fundName || index.toString()}
          renderItem={({ item }) => <PositionItem {...item} />}
        />
      </VStack>
    </VStack>
  );
};
